module.exports = __webpack_public_path__ + "img/flecha.487b65be.webp";